<template>
  <v-dialog
    scrollable
    v-model="open"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="700px"
    style="z-index: 1001"
  >
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">Filtrer kartlag ({{ layer.title }})</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <p>
          Her kan du filtrere hva som vises i kartlaget ved hjelp av egenskapene
          til elementene i kartlaget. Du kan enten bruke SQL designeren under
          for å bygge opp et filter, eller skrive inn en SQL spørring selv ved å
          velge fanen
          <i>SQL tekst</i>. Se
          <a
            href="https://desktop.arcgis.com/en/arcmap/10.3/map/working-with-layers/building-a-query-expression.htm"
            >denne siden</a
          >
          for mer informasjon om bruk av SQL spørringer i ArcGIS plattformen.
        </p>
        <layer-query-dialog
          :rules="rules"
          :layer="layer"
          @query-updated="updateSqlString"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat large @click="$emit('close')">Avbryt</v-btn>

        <v-btn color="primary" flat large @click="saveDefinitionExpression"
          >OK</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MappingMixin from "@/mixins/mappingMixin";
import LayerQueryDialog from "@/pages/MapPage/Tools/Layers/LayerQueryDialog.vue";
export default {
  name: "layer-item-filter",
  data: function() {
    return {
      sqlString: "",
      query: null,
      mode: "interactive"
    };
  },
  mixins: [MappingMixin],
  computed: {
    layerInfo() {
      return this.$store.getters["getLayerInfoByUrl"](this.layer.url);
    },
    rules() {
      let queryRules = [];
      if (this.layerInfo) {
        this.layerInfo.fields.forEach(field => {
          let fieldQueryRule = this.getFieldQueryRule(field);
          if (fieldQueryRule !== null) {
            queryRules.push(fieldQueryRule);
          }
        });
      }
      return queryRules;
    }
  },
  watch: {},
  methods: {
    getFieldQueryRule: function(field) {
      if (
        field.name == "OBJECTID" ||
        field.name == "Shape" ||
        field.name == "GlobalID"
      ) {
        return null;
      }
      let type = "";
      let choices = [];
      if (field.domain !== null) {
        if (typeof field.domain.codedValues[0].code === "number") {
          type = "selectNumeric";
        } else {
          type = "select";
        }
        choices = this.getFieldDomainChoices(field.domain);
      } else {
        type = this.getFieldType(field.type);
      }

      let label = field.name;
      let id = field.name;
      return { type, id, label, choices };
    },
    saveDefinitionExpression: function() {
      this.layer.definitionExpression = this.sqlString;

      this.updateLayerDefinitionExpression({
        parentLayerID: this.layer.layer.id,
        sublayerIndex: this.layer.id,
        id: this.layer.url,
        query: this.query,
        sqlString: this.sqlString
      });
      this.$eventHub.$emit("layer-filter-set", this.layer);
      this.$emit(
        "filter-active-changed",
        this.layer.definitionExpression !== null &&
          this.layer.definitionExpression !== ""
      );
      this.$emit("close");
    },
    updateSqlString: function(newQuery) {
      this.sqlString = newQuery.sql;
      this.query = newQuery.query;
    },
    getFieldDomainChoices: function(esriFieldDomain) {
      let choices = [];
      esriFieldDomain.codedValues.forEach(codedValue => {
        choices.push({
          label: codedValue.name,
          value: codedValue.code
        });
      });

      return choices;
    },
    getFieldType: function(esriFieldType) {
      let fieldType;

      switch (esriFieldType) {
        case "esriFieldTypeInteger":
          fieldType = "numeric";
          break;
        case "esriFieldTypeSmallInteger":
          fieldType = "numeric";
          break;
        case "esriFieldTypeDouble":
          fieldType = "numeric";
          break;
        case "esriFieldTypeString":
          fieldType = "text";
          break;
        case "esriFieldTypeDate":
          fieldType = "text";
          break;
        case "esriFieldTypeOID":
          fieldType = "numeric";
          break;
        case "esriFieldTypeGlobalID":
          fieldType = "text";
          break;
      }

      return fieldType;
    }
  },
  props: {
    layer: Object,
    open: Boolean
  },
  components: {
    LayerQueryDialog
  },
  mounted() {
    if (!this.layerInfo) {
      this.loadLayerInfo({
        url: this.layer.url
      });
    }
  }
};
</script>

<style></style>
